<template>
  <ca-input
    ref="codeInput"
    v-model="code"
    :on-blur="checkStockCode"
    :custom-validations="codeValidation"
    required></ca-input>
</template>

<script>
import { checkStockCode } from '../stockingService';

export default {
  name: 'StockCodeInput',
  props: {
    value: String,
  },
  data() {
    return {
      existentCodes: [],
      code: this.value,
      codeValidation: [{
        message: 'Esse código já existe.',
        valid: value => {
          return !this.existentCodes.includes(value);
        },
      }],
    };
  },
  methods: {
    checkStockCode(code) {
      checkStockCode(code)
        .then(response => {
          if (!response) {
            this.$emit('change', code);
            return;
          }

          this.existentCodes.push(code);
          this.$refs.codeInput.$emit('blur');
        });
    },
  },
};
</script>
